import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { slot: "start" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { slot: "end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "toolbar-start", {}, () => [
                (!_ctx.hideCancel)
                  ? (_openBlock(), _createBlock(_component_ion_buttons, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                        }, {
                          default: _withCtx(() => [
                            (_ctx.withBackIcon)
                              ? (_openBlock(), _createBlock(_component_ion_icon, {
                                  key: 0,
                                  slot: "icon-only",
                                  icon: _ctx.chevronBack
                                }, null, 8, ["icon"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.cancelText), 1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "toolbar-end", {}, () => [
                (!_ctx.hideConfirm)
                  ? (_openBlock(), _createBlock(_component_ion_buttons, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          strong: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.confirmText), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 3
        }),
        _renderSlot(_ctx.$slots, "header-append")
      ]),
      _: 3
    }),
    _createVNode(_component_ion_content, {
      class: _normalizeClass(_ctx.paddingClass)
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"])
  ], 64))
}